module.exports = __webpack_public_path__ + "img/ceptinel-present-financial-services-forum.85eeb60b.png";